module.exports = __webpack_public_path__ + "static/media/pid_4.9c88ec23.svg";